import m from 'mithril'

export default {
  view: vnode => {
    const arc = require('./arc.png')
    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-26-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>        
        <h3 className="log-book-text mod-h3">Den Kolde Krig - frem til 1962</h3>

        <p className="log-book-text">Den Kolde Krig er den storpolitiske konflikt mellem verdens to supermagter USA og Sovjetunionen. Konflikten begynder efter 2. Verdenskrig og bliver kaldt for “Den Kolde Krig”, fordi supermagterne ikke er i direkte væbnet konfrontation med hinanden. I 1962 er spændingen så stærk, at verden frygter en atomkrig. </p>

        <h3 className="log-book-text mod-h3">1945-49: Delingen af Europa </h3>
<p className="log-book-text">Efter 2. Verdenskrig deler sejrherrerne kontrollen over Europa. Sovjetunionen kontrollerer den østlige zone og USA, England og Frankrig den vestlige. Tyskland bliver delt i to stater. </p>

<h3 className="log-book-text mod-h3">1947: Truman-doktrin og Marshall-hjælp</h3>
<p className="log-book-text">USA's præsident Harry S. Truman fastslår, at USA skal ”inddæmme” kommunismen til de områder, som allerede er under Sovjetunionens kontrol. Amerikanerne vil gribe ind overalt i verden, hvis demokratiet er truet. USA investerer med den såkaldte Marshall-hjælp massivt i at genopbygge Europa.  </p>

<h3 className="log-book-text mod-h3">1948: Kup i Tjekkoslovakiet</h3>
<p className="log-book-text">Kommunisterne tager magten i Tjekkoslovakiet med støtte fra Sovjetunionen. </p>

<h3 className="log-book-text mod-h3">1949: NATO og musketereden</h3>
<p className="log-book-text">USA, Danmark og 10 andre lande danner NATO (North Atlantic Treaty Organisation). 
Landene forpligter sig til at forsvare hinanden: “Ethvert angreb på en allieret vil blive betragtet som et angreb på os alle,” står der i traktaten. Det kaldes ‘musketereden’. 
Samme år foretager Sovjetunionen sin første atomprøvesprængning. </p>

<h3 className="log-book-text mod-h3">1949: Maos Kina fødes</h3>
<p className="log-book-text">Efter årtiers borgerkrig danner kommunisterne med formand Mao Zedong i spidsen Folkerepublikken Kina.</p>     

<h3 className="log-book-text mod-h3">1950-53: Koreakrigen</h3>
<p className="log-book-text">Det kommunistiske Nordkorea angriber Sydkorea. Med USA i front slår FN-styrker angrebet tilbage og invaderer Nordkorea, som får støtte fra Kina og Sovjet. Tre millioner mennesker dør. </p>

<h3 className="log-book-text mod-h3">1955: Warszawa-pagten</h3>
<p className="log-book-text">Vesttyskland indtræder i NATO. Som modreaktion danner Sovjetunionen Warszawapagten - en tæt militær alliance mellem landene i Østblokken. Reelt er det også en formalisering af Sovjetunionens magt over de øvrige lande.  </p>

<h3 className="log-book-text mod-h3">1956: Opstand i Ungarn</h3>
<p className="log-book-text">En opstand mod det kommunistiske styre i Ungarn knuses af Sovjetunionen. </p>

<h3 className="log-book-text mod-h3">1956: Suezkrisen</h3>
<p className="log-book-text">Egypten vil tage magten over Suezkanalen, som er vigtig for verdens skibsfart. Israel, Frankrig og England intervenerer militært. Sovjetunionen truer med at bruge atombomber mod London og Paris. Frankrig og England trækker sig efter pres fra både USA og Sovjetunionen. FN sætter fredsbevarende styrker ind, og adgangen gennem kanalen garanteres. </p>

<h3 className="log-book-text mod-h3">1961: Berlinmuren</h3>
<p className="log-book-text">En 45,1 kilometer lang mur bliver opført tværs gennem Berlin. Siden delingen af Tyskland har flere end 2,6 millioner mennesker forladt Østtyskland. Der er nu ordre om fra østtysk side at skyde alle, som forsøger at krydse grænsen mod Vest.</p>

<h3 className="log-book-text mod-h3">1962: Cubakrisen</h3>
<p className="log-book-text">Sovjetunionen placerer atomsprænghoveder i Cuba. Missilerne kan nemt ramme USA. 
USA truer Sovjet med krig. Verden befinder sig på kanten af en altødelæggende atomkrig.</p>
 
<h3 className="log-book-text mod-h3">1963:?</h3>

        </div>
      </div>
    )
  }
}
